<template>
<div>
    <div>
        {{this.data.PaymentDiscountPrice}}
        <span class="cs-redLabel" v-if="data.IsRefund">(退课)</span>
    </div>
    <div v-show="additionalText != ''">
        <el-tooltip class="item" effect="dark" :content="data.ChangeCourseRemark" placement="top-start">
            <span>{{additionalText}}</span> 
        </el-tooltip>
    </div>
</div>
</template>

<style lang="scss" scoped>
.cs-accountList-payment {
    span {
        display: inline-block;
        margin-right: 1px;
    }
}

.gray {
    color: gray;
    margin-left: 3px;
}

.margin-left-10 {
    margin-left: 10px;
}

.search-InputBox {
    width: 140px;
}
</style>

<script>
 export default {
     props: {
         data: {},
         columnData: {},
         status: {},
         editLocation: {},
     },
     data() {
         return {
             additionalText: ''
         };
     },
     components: {},
     created() {
         this.init();
     },
     methods: {
         init() {
             
             if (this.data.ChangeCourseDifferentPrice > 0) {
                 this.additionalText = "(" + this.data.PaymentDiscountPriceNoDiff + "+" + this.data.ChangeCourseDifferentPrice + ")"
             }else{
                 this.additionalText = "";
             }
         }
     },
     watch: {
         data: function () {
             this.init();
         }
     }
 };
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/salesQueryPaymentDiscoutCell.vue